import ReactOnRails from 'react-on-rails';
import LandingApp from "../bundles/Landing/LandingApp";

ReactOnRails.register({
  LandingApp,
});
